export default "__VITE_ASSET__Cwbh6san__"